import { Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/system";
import { formatColumnName } from "../utils";
import MDTypography from "components/MDTypography";

// **** Components ****//

export const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        textWrap: "unwrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
        height: "auto",
        padding: "6px",
    },
}));

export const StackSkeleton = () => {
    return (
        <Stack spacing={0.5}>
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
        </Stack>
    );
};

const renderTableCell = (data) => {
    // If the data is an object (JSON), render each key-value pair
    if (typeof data === "object" && data !== null) {
        return (
            <Table>
                <TableBody>
                    {Object.entries(data).map(([key, value]) => (
                        <TableRow key={key}>
                            <TableCell sx={{ padding: "1px!important;" }}>
                                {formatColumnName(key)}
                            </TableCell>
                            <TableCell sx={{ padding: "1px!important;" }}>
                                {renderTableCell(value)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
    if (typeof data === 'boolean') {
        return data ? 'True' : 'False'
    }
    return data;
};

export const DynamicDataTable = (Alert) => {
    // Parse JSON data and extract keys for table columns
    const columns = Object.keys(Alert);

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column}
                                sx={{
                                    padding: "0px!important;",
                                    color: "#7b809a !important;",
                                }}
                            >
                                {formatColumnName(column)}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column}>
                                {renderTableCell(Alert[column])}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export function devStyle(isTabletOrMobile) {
    return {
        table: {
            padding: 0,
            borderSpacing: 0,
            borderCollapse: "collapse",
        },
        cell: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "15px",
            paddingRight: isTabletOrMobile ? "0" : "15px",
            width: "56%",
        },
        cell1: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "15px",
            paddingRight: isTabletOrMobile ? "0" : "15px",
            width: isTabletOrMobile ? "135px" : "175px",
        },
    }
}

const RenderTH = ({ value, styles }) => {
    return (
        <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
            <MDTypography fontSize={1}>
                <span style={{ fontWeight: "700" }}>{value}:</span>
            </MDTypography>
        </th>
    );
};

const RenderTD = ({ value, style = null, fun = () => { } }) => {
    return (
        <td style={style} onClick={fun}>
            <MDTypography fontSize={1}>{value}</MDTypography>
        </td>
    );
};

export const RenderTR = ({ th, td, tdStyle: customTdStyle, tdFun, styles }) => {
    const mergedTdStyle = {
        ...customTdStyle,
        padding: "0px 15px",
    };

    return (
        <>
            {!["", null, undefined].includes(td) && (
                <>
                    <RenderTH value={th} styles={styles} />
                    <RenderTD value={td} style={mergedTdStyle} fun={tdFun} />
                </>
            )}
        </>
    );
};

export const DisplayGeofenceLocation = ({ parameter_name, geofence, geofenceIcon, styles }) => {

    if (parameter_name !== 'moment_status_duration') {
        return
    }
    if (!geofence) {
        return
    }

    return (
        <TableRow key={'geofenceName'}>
            <TableCell
                style={styles.cell}
            >
                <MDTypography fontSize={1}>
                    <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                        {geofenceIcon ? <i className={geofenceIcon?.class_name}></i> : ''}
                        Geofence:
                    </strong>
                </MDTypography>
            </TableCell>
            <TableCell
                style={styles.cell}
                title={geofence?.geofence_id}
            >
                <MDTypography fontSize={1} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                    {geofence?.name} <div style={{ width: '15px', height: '15px', borderRadius: '50%', display: 'inline-block', backgroundColor: geofence?.color }} title={geofence?.color}></div>
                </MDTypography>

            </TableCell>
        </TableRow>
    )
}